import { apiClient } from './client';
import type { ApiResponse } from '../types/api';

export interface UserSettings {
  id?: number;
  user_id?: number;
  push_notifications: boolean;
  email_notifications: boolean;
  weekly_report: boolean;
  weekly_report_day: number;    // 1=Monday, 7=Sunday
  weekly_report_hour: number;   // 0-23
  weekly_report_method: 'email' | 'push' | 'both';
  auto_trigger_cooldown: boolean;
  consecutive_loss_threshold: number;
  default_cooldown_duration: number;
  breakeven_threshold: number;
  dark_mode: boolean;
  language: string;
  created_at?: string;
  updated_at?: string;
}

export interface DeleteAccountRequest {
  password: string;
  confirmation: string; // 必须是 "DELETE"
}

export const settingsApi = {
  // 获取用户设置
  getSettings: (): Promise<ApiResponse<UserSettings>> =>
    apiClient.get('/settings'),

  // 更新用户设置
  updateSettings: (settings: UserSettings): Promise<ApiResponse<UserSettings>> =>
    apiClient.put('/settings', settings),

  // 导出用户数据
  exportData: (): Promise<Blob> =>
    apiClient.get('/auth/export-data', { responseType: 'blob' }),

  // 删除账户
  deleteAccount: (data: DeleteAccountRequest): Promise<ApiResponse<null>> =>
    apiClient.delete('/auth/delete-account', { data }),
};
